// import { Box } from "@mui/material";
// import DocumentTable from "./DocumentTable";

// export default function ResultsPanel() {
//   return (
//     <Box width={400} borderRight="1px solid #ddd" overflow="auto">
//       <DocumentTable />
//     </Box>
//   );
// }


import { Box } from "@mui/material";
import DocumentTable from "./DocumentTable";

export default function ResultsPanel({setSelectedDoc}) {
  return (
    <Box width={400} borderRight="1px solid #ddd" overflow="auto" height='100%'>
      <DocumentTable setSelectedDoc={setSelectedDoc}/>
    </Box>
  );
}